import { Backdrop } from "@mui/material";
import { Oval } from "react-loader-spinner";

export const LoadingIndicator = ({ loading }: {
    loading: boolean
}) => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
        >
            <div style={{ position: "absolute", width: 80, marginLeft: "auto", marginRight: "auto", top: "calc(50%)", left: "calc(50%)", zIndex: 9999 }}>
                <Oval color="#3f51b5" secondaryColor="#9ea7da" height={80} width={80} visible={true} />
            </div>
        </Backdrop>
    );
}